import type { ZoomLevel } from './types';

export const CONFIG = {
    DEFAULT_HEIGHT: 130,
    EXPANDED_HEIGHT: 400,
    ZOOM_COOLDOWN: 500,
    DRAG_SENSITIVITY: 0.1,
    WIDTH_ESTIMATE: 380,
    CHART_MARGINS: { top: 10, right: 10, bottom: 20, left: 45 }, // bottom 35

    WINDOW_SIZES: {
        year: 5,
        month: 6,
        day: 5,
    } as Record<ZoomLevel, number>,

    EXPANDED_WINDOW_SIZES: {
        year: 5,
        month: 12,
        day: 12,
    } as Record<ZoomLevel, number>,

    DEFAULT_TICKS: {
        amount: [0, 20000, 40000, 60000, 80000] as number[],
        count: [0, 4, 8, 12, 16] as number[],
    },

    SCALE_MAX_VALUES: {
        amount: 80000,
        count: 16,
    },
} as const;
